import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import "./CategorySection.css"

const API_URL = "https://data.lacegota.in/api/categories-with-images"
const PRODUCT_API_URL = "https://data.lacegota.in/wp-json/wc/store/v1/products"
const PLACEHOLDER_IMAGE = "/placeholder.jpg"

const getCategoryImageUrl = (image) => {
  if (!image) return ""
  if (typeof image === "string") return image
  if (Array.isArray(image) && image.length > 0) {
    return image[0]?.src || image[0] || ""
  }
  return image.src || ""
}

const getFirstProductImageUrl = async (categoryId) => {
  try {
    const response = await fetch(`${PRODUCT_API_URL}?category=${categoryId}&per_page=1`)
    if (!response.ok) return ""

    const products = await response.json()
    return products?.[0]?.images?.[0]?.src || ""
  } catch (error) {
    console.error("Category product image fallback error:", error)
    return ""
  }
}

function CategorySection() {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let isMounted = true

    const loadCategories = async () => {
      try {
        const response = await fetch(API_URL)
        const data = await response.json()

        if (Array.isArray(data)) {
          const mainCategories = data.filter(cat => cat.parent === 0)
          const categoriesWithImages = await Promise.all(
            mainCategories.map(async (cat) => {
              const categoryImageUrl = getCategoryImageUrl(cat.image)
              const productImageUrl = await getFirstProductImageUrl(cat.id)

              return {
                ...cat,
                imageUrl: categoryImageUrl || productImageUrl,
                fallbackImageUrl: productImageUrl || categoryImageUrl,
              }
            })
          )

          if (isMounted) {
            setCategories(categoriesWithImages)
          }
        }
      } catch (err) {
        console.error("Category Fetch Error:", err)
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    loadCategories()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <section className="categorySection">
      <h2 className="categoryTitle">🛍️ Shop By Category</h2>

      <div className="categoryGrid">
        {loading ? (
          <div className="loadingContainer">
            <div className="spinner"></div>
            <p>Loading categories...</p>
          </div>
        ) : (
          categories.map((cat) => (
            <Link to={`/category/${cat.slug}`} className="catTileLink" key={cat.id}>
              <div className="catTileCard">
                <div className="catImageContainer">
                  <img
                    src={cat.imageUrl || cat.fallbackImageUrl || PLACEHOLDER_IMAGE}
                    alt={cat.name}
                    
                    onError={(event) => {
                      if (event.currentTarget.dataset.fallbackUsed !== "true" && cat.fallbackImageUrl) {
                        event.currentTarget.dataset.fallbackUsed = "true"
                        event.currentTarget.src = cat.fallbackImageUrl
                        return
                      }

                      event.currentTarget.onerror = null
                      event.currentTarget.src = PLACEHOLDER_IMAGE
                    }}
                  />
                </div>

                <div className="catTileInfo">
                  <p className="catNameText">{cat.name}</p>
                  <div className="shopNowWrapper">
                    <span className="shopNowAction">Shop Now</span>
                  </div>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </section>
  )
}

export default CategorySection
